/*!
 * Copyright (c) 2026 Elevation Technologies Pte Ltd.
 * Developer: filimoni@elevationtech.com.fj
 */
import React, { useEffect } from 'react';

export default function PhotoLightbox({ images = [], activeIndex, setActiveIndex, label = 'Photo gallery' }) {
  const activeImage = Number.isInteger(activeIndex) ? images[activeIndex] : null;

  useEffect(() => {
    if (!activeImage) {
      return undefined;
    }

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setActiveIndex(null);
      }

      if (event.key === 'ArrowRight') {
        setActiveIndex((currentIndex) => (currentIndex + 1) % images.length);
      }

      if (event.key === 'ArrowLeft') {
        setActiveIndex((currentIndex) => (currentIndex - 1 + images.length) % images.length);
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [activeImage, images.length, setActiveIndex]);

  if (!activeImage) {
    return null;
  }

  const showNextImage = (direction) => {
    setActiveIndex((currentIndex) => (currentIndex + direction + images.length) % images.length);
  };

  return (
    <div className="fsf-lightbox" role="dialog" aria-modal="true" aria-label={label} onClick={() => setActiveIndex(null)}>
      <button className="fsf-lightbox__close" type="button" onClick={() => setActiveIndex(null)}>
        Close
      </button>
      {images.length > 1 ? (
        <button
          className="fsf-lightbox__nav fsf-lightbox__nav--prev"
          type="button"
          onClick={(event) => {
            event.stopPropagation();
            showNextImage(-1);
          }}
        >
          Prev
        </button>
      ) : null}
      <figure className="fsf-lightbox__figure" onClick={(event) => event.stopPropagation()}>
        <img src={activeImage.src} alt={activeImage.alt || `Freight Services Fiji photo ${activeIndex + 1}`} />
        <figcaption>
          {activeImage.alt || `Photo ${activeIndex + 1} of ${images.length}`}
        </figcaption>
      </figure>
      {images.length > 1 ? (
        <button
          className="fsf-lightbox__nav fsf-lightbox__nav--next"
          type="button"
          onClick={(event) => {
            event.stopPropagation();
            showNextImage(1);
          }}
        >
          Next
        </button>
      ) : null}
    </div>
  );
}
